import { 
  collection, 
  query, 
  where, 
  onSnapshot, 
  addDoc, 
  updateDoc, 
  doc, 
  serverTimestamp, 
  orderBy 
} from 'firebase/firestore';
import { db, auth } from '../firebaseConfig';

// Subscribe to user's unread notifications
export const subscribeToNotifications = (callback) => {
  if (!auth.currentUser) return () => {};

  const userId = auth.currentUser.uid;
  console.log('Starting subscription for:', userId);

  const q = query(
    collection(db, 'notifications'),
    where('recipientId', '==', userId),
    where('read', '==', false),
    orderBy('createdAt', 'desc')
  );

  return onSnapshot(q, (snapshot) => {
    const notifications = [];
    snapshot.forEach((doc) => {
      console.log('Notification found:', doc.data());
      notifications.push({
        id: doc.id,
        ...doc.data()
      });
    });
    console.log('Total unread notifications:', notifications.length);
    callback(notifications);
  }, error => {
    console.error('Subscription error:', error);
  });
};

// Create a new notification
export const createNotification = async (postId, postOwnerId, commentText) => {
  try {
    console.log('Creating notification for:', postOwnerId);

    const notificationData = {
      postId,
      recipientId: postOwnerId,
      commenterId: auth.currentUser.uid,
      commenterName: auth.currentUser.displayName || 'Unknown',
      content: commentText,
      type: 'comment',
      createdAt: serverTimestamp(),
      read: false
    };

    const docRef = await addDoc(collection(db, 'notifications'), notificationData);
    console.log('Created notification:', docRef.id);
    return docRef.id;
  } catch (error) {
    console.error('Error creating notification:', error);
  }
};

// Mark a notification as read
export const markNotificationAsRead = async (notificationId) => {
  try {
    await updateDoc(doc(db, 'notifications', notificationId), {
      read: true
    });
    console.log(`Notification ${notificationId} marked as read.`);
  } catch (error) {
    console.error('Error marking notification as read:', error);
  }
};

export default {
  subscribeToNotifications,
  createNotification, 
  markNotificationAsRead
};